const e=(e,t,n)=>{let r=encodeURIComponent(n);return`otpauth://totp/${r}:${encodeURIComponent(t)}?secret=${e}&issuer=${r}&algorithm=SHA1&digits=6&period=30`};export{e as buildOtpAuthUrl};
//# sourceMappingURL=totp.mjs.map